import { templateJoin } from 'bernie-graphql';

export const conversationsQuery = templateJoin`
        query Conversations($propertyId: String!) {
  lodgingConversations(propertyId: $propertyId) {
    newConversation {
      form {
        actionText
        comment {
          label
          placeholder
          invalid
          required
        }
        emailAddress {
          label
          placeholder
          invalid
          required
        }
        name {
          label
          placeholder
          invalid
          required
        }
        resultText
      }
      title
    }
  }
}

    `;

export const addPropertyToCartQuery = templateJoin`
        mutation AddPropertyToCart($id: UUID!, $context: ContextInput!, $propertyOffer: PropertyOfferInput!, $cartPropertySearchContextInput: CartPropertySearchContextInput!){
    cartItems(
        id: $id, context: $context
    ) {
        addProperty(key: $propertyOffer, searchContext: $cartPropertySearchContextInput) {
            id
            itemCount
        }
    }
}

    `;
export const createQuestionQuery = templateJoin`
        mutation CreateQuestion($context: ContextInput!, $question: String!, $email: String!, $productId: String!, $questioner: String!, $productQuestionTopic: ProductQuestionTopic!) {
    askProductQuestion(context: $context, question: $question, email: $email, productId: $productId, questioner: $questioner, productQuestionTopic: $productQuestionTopic)
}

    `;
export const createLodgingConversationQuery = templateJoin`
        mutation CreateLodgingConversation($message: String!, $metadata: LodgingConversationMetadataInput!) {
  createLodgingConversation(message:$message, metadata: $metadata) {
    result
    action,
    alert,
    id
  }
}
    `;
export const createSessionCartQuery = templateJoin`
        mutation CreateSessionCart($context: ContextInput!, $cartOptions: CartOptionsInput!) {
    createSessionCart(
        context: $context
        cartOptions: $cartOptions
    ) {
        id
    }
}

    `;
export const customerQuery = templateJoin`
        query Customer($context: ContextInput!, $semdtl: String) {
    customer(context: $context, semdtl: $semdtl) {
        currentTripIntent {
            why {
                interests {
                    name
                    desmetId
                }
            }
        }
    }
}

    `;
export const cartQuery = templateJoin`
        query Cart($context: ContextInput!, $id: UUID) {
    cart(
        id: $id, context: $context
    ) {
      itemCount
      items {
        id
        ... on PropertyCartItem {
          offers {
            offerIndex
            naturalKeys {
              id
              roomTypeId
              ratePlanId
              checkIn {
                isoFormat
              }
              checkOut {
                isoFormat
              }
              inventoryType
              rooms {
                 numberOfAdults
                 childAges
              }
            }
            offer {
                marketingChannelId
                units {
                    name
                    photos {
                        description
                        url
                    }
                    ratePlans {
                        priceDetails {
                            availability {
                                available
                                minRoomsLeft
                            }
                            price {
                                total {
                                    currency {
                                        code
                                        name
                                        symbol
                                    }
                                    formatted
                                    raw
                                }
                                lead {
                                    currency {
                                        code
                                        name
                                        symbol
                                    }
                                    formatted
                                    raw
                                }
                            }
                            priceAfterLoyaltyPointsApplied {
                                total {
                                    currency {
                                        code
                                        name
                                        symbol
                                    }
                                    formatted
                                    raw
                                }
                                lead {
                                    currency {
                                        code
                                        name
                                        symbol
                                    }
                                    formatted
                                    raw
                                }
                            }
                            fees {
                                description
                            }
                        }
                    }
                }
            }
          }
          summary {
            name
            location {
              address {
                city
              }
            }
          }
          gallery {
            featured {
              url
            }
          }
        }
      }
    }
  }

    `;

export const findAnswersSearchQuery = templateJoin`
        query FindAnswersSearch($context: ContextInput!, $propertyId: String!, $reviewPagination: PaginationInput!, $reviewSortBy: PropertyReviewSort!, $reviewFilters: PropertyReviewFiltersInput!, $questionFilters: ProductQuestionFiltersInput!, $questionPagination: PaginationInput!, $productQuestionTopic: ProductQuestionTopic!, $questionDateFormat: String!) {
    propertyInfo(propertyId: $propertyId,  context: $context) {
        reviewInfo(sortBy: $reviewSortBy, pagination: $reviewPagination, filters: $reviewFilters) {
            summary {
                superlative
                totalCount {
                    raw
                    formatted
                }
                averageOverallRating {
                    raw
                    formatted
                }
                cleanliness {
                    raw
                    formatted
                }
                serviceAndStaff {
                    raw
                    formatted
                }
                amenityScore {
                    raw
                    formatted
                }
                hotelCondition {
                    raw
                    formatted
                }
                cleanlinessPercent
                serviceAndStaffPercent
                amenityScorePercent
                hotelConditionPercent
                ratingCounts {
                    count {
                        formatted
                        raw
                    }
                    percent
                    rating
                }
                lastIndex
            }
            reviews {
                id
                ratingOverall
                superlative
                submissionTime {
                    raw
                }
                title
                text
                locale
                author
                userLocation
                stayDuration
                helpfulReviewVotes
                negativeRemarks
                positiveRemarks
                locationRemarks
                photos {
                    description
                    url
                }
                managementResponses {
                    id
                    date
                    displayLocale
                    userNickname
                    response
                }
                travelers
                themes {
                    icon {
                        id
                        description
                    }
                    label
                }
            }
        }
    },
    productQuestions(context: $context, productId: $propertyId, filters: $questionFilters, questionPagination: $questionPagination, productQuestionTopic: $productQuestionTopic) {
        totalCount {
            raw
        }
        questions {
            answers {
                answer
                answerTime {
                    formatted(format: $questionDateFormat),
                    raw
                }
                displayName
                id
                upVotes {
                    raw
                }
            }
            createDate {
                formatted(format: $questionDateFormat),
                raw
            }
            id
            question
            questioner
            totalAnswers {
                raw
            }
        }
    }
}

    `;

export const fullPropertySearchQuery = templateJoin`
        query FullPropertySearch(
    $context: ContextInput!,
    $destination: DestinationInput!,
    $rooms: [RoomInput!],
    $dateRange: PropertyDateRangeInput,
    $sort: PropertySort,
    $filters: PropertySearchFiltersInput,
    $marketing: PropertyMarketingInfoInput,
    $legacyCriteria: LegacyPropertySearchCriteriaInput,
    $searchOptions: [PropertySearchOptions!],
    $searchPagination: PaginationInput,
    $searchIntent: SearchIntentInput,
    $shoppingContext: ShoppingContextInput
) {
    propertySearch(context: $context, destination: $destination, rooms: $rooms, dateRange: $dateRange, sort: $sort, filters: $filters, marketing: $marketing, legacyCriteria: $legacyCriteria, searchOptions: $searchOptions, searchPagination: $searchPagination, searchIntent: $searchIntent, shoppingContext: $shoppingContext) {
        searchCriteria {
            dateRange {
                checkInDate {
                    day
                    month
                    year
                }
                checkOutDate {
                    day
                    month
                    year
                }
            }
            destination {
                regionId
                regionName
            }
            searchIntent {
                theme
                userIntent
                semdtl
            }
            sort
            filters {
                accessibility
                amenities
                bedroomFilter
                deals
                paymentType
                poi
                priceBuckets
                propertyName
                propertyStyles
                reviewScore {
                    min
                    max
                }
                starList
                structureTypes
                travelerType
            }
        }
        sortAndFilter {
            defaults {
                sort
                regionId
            }
            selected {
                priceFilterPills {
                    aggregate {
                        label
                        value
                    }
                    buckets
                }
                star
            }
            options {
                appliedFilterCount
                sortAndFilter {
                    selected
                    isRange
                    label
                    max
                    min
                    name
                    placeholder
                    step
                    subLabel
                    hiddenThreshold: seeMoreOptionsToggleThreshold
                    options {
                        selectedLabel
                        ariaLabel
                        description
                        icon
                        isSelected
                        label
                        value
                        optionValue
                        range {
                            min
                            max
                        }
                        filterCategory
                    }
                }
            }
        }
        properties {
            name
            id
            infositeURL
            star
            starRatingIcon
            availability {
                available
                text
                theme
            }
            offerSummary {
                message
                theme
                messages {
                    message
                    theme
                    type
                }
            }
            reviews {
                score
                localizedScore
                total
                localizedTotal
                superlative
                localizedSubtitle
            }
            price {
                lead {
                    formatted
                }
                strikeOutType
                strikeOut {
                    formatted
                }
                roomNightMessage,
                priceMessages {
                    value
                }
            }
            priceAfterLoyaltyPointsApplied {
                lead {
                    formatted
                }
                strikeOutType
                strikeOut {
                    formatted
                }
            }
            thumborImage {
                url
                description
            }
            gallery {
                url
                description
            }
            mapMarker {
                icon
                label
                type
                latLong {
                    latitude
                    longitude
                }
            }
            neighborhood {
                name
            }
            offerBadge {
                primary {
                    text
                    theme_temp
                    icon_temp {
                        id
                        description
                    }
                }
                secondary {
                    text
                    theme_temp
                    icon_temp {
                        id
                        description
                    }
                }
            },
            pinnedDetails {
                heading
            },
            destinationInfo {
                distanceFromMessaging
            }
            vipMessaging
            propertyTypeBadge
            supportingMessages
            shortList {
                favorited
                saveUrl
                removeUrl
                metaData {
                    chkIn
                    chkOut
                    hotelId
                    roomConfiguration
                }
            }
            sponsoredListing {
                id
                clickRedirectTrackingUrl
                clickTrackingUrl
                details
                detailsHeadline
                hotelImage
                impressionTrackingUrl
                trackingData
                brand
                clickRedirectLinkoffTrackingUrl
                logo
                lotagline
                rating
                slots
                vanityUrl
                rank
                position
            }
            highlightedPropertyDetail
        }
        summary {
            resultsSummary {
                __typename
                value
                ... on LodgingLinkMessage {
                    ...FullSearchLinkMessage
                }
            }
            pricedHotelSize
            region {
                name
                id
            }
            messages {
                title {
                    text
                    icon {
                        description
                        id
                    }
                    theme
                }
                subtitle {
                    text
                    icon {
                        description
                        id
                    }
                    theme
                }
                action {
                    primary{
                        text
                        linkUrl
                        referrerId
                        actionDetails {
                            name
                            details
                        }
                    }
                    secondary{
                        text
                        linkUrl
                        referrerId
                        actionDetails {
                            name
                            details
                        }
                    }
                }
                index
            }
            loyaltyEducation {
                title
                content {
                    __typename
                    ... on LoyaltyPointsEducation {
                        description
                        programFeatures {
                            title
                            perks {
                                descriptions
                                icon
                            }
                            description
                        }
                    }
                    ... on LoyaltyProgramEducation {
                        perks {
                            descriptions
                            icon
                        }
                        joinProgramText
                    }
                }
                action {
                    text
                    rfrr
                    href
                }
            }
            loyaltyInfo {
                pointsAppliedMessage
                saveWithPointsMessage
                saveWithPointsActionMessage
            }
            matchedPropertiesSize
        }
      	map {
            bounds {
                northeast {
                    latitude
                    longitude
                }
                southwest {
                    latitude
                    longitude
                }
            }
            center {
                latitude
                longitude
            }
            staticMapSrc
            title
            zoom
            messagingModel {
                title {
                    text
                    theme
                    icon {
                        description
                        id
                    }
                }
                subtitle {
                    text
                    theme
                    icon {
                        description
                        id
                    }
                }
                type
            }
      }
      shoppingContext {
          multiItem {
              id
          }
      }
    }
}

fragment FullSearchLinkMessage on LodgingLinkMessage {
    link {
        ...FullSearchLink
    }
    icon {
        id
    }
}

fragment FullSearchLink on LodgingLink {
    url
    referrerId
}

    `;

export const propertyLocationScoreInfoQuery = templateJoin`
        query PropertyLocationScoreInfo($propertyIds: [String!]!, $context: ContextInput!) {
    propertyReviewAggregates(
        propertyIds: $propertyIds,
        context: $context
    ) {
        propertySummaries {
            propertyId
            locationScore {
                score
                tags {
                    label
                }
            }
        }
    }
}

    `;

export const prepareCheckoutByCartIdQuery = templateJoin`
        mutation PrepareCheckoutByCartId($context: ContextInput!, $id: UUID!, $totalPrice: MoneyInput!, $marketingChannelId: Int) {
    prepareCheckoutByCartId(context: $context, cartId: $id, totalPrice: $totalPrice, marketingChannelId: $marketingChannelId) {
        tripId
        checkoutUrl
        failureReason {
            ... on MaxRoomsFailure {
                groupLinkMessage
                message
            }
        }
    }
}

    `;

export const prepareCheckoutQuery = templateJoin`
        mutation PrepareCheckout($context: ContextInput!, $properties: [PropertyNaturalKeyInput!], $cookies: String!) {
    prepareCheckout(context: $context, properties: $properties, cookies: $cookies) {
        tripId
        checkoutUrl
    }
}

    `;

export const propertyRoomScoreInfoQuery = templateJoin`
        query PropertyRoomScoreInfo($propertyIds: [String!]!, $context: ContextInput!) {
    propertyReviewAggregates(
        propertyIds: $propertyIds,
        context: $context
    ) {
        propertySummaries {
          propertyId
          roomsScore {
            id
            score
            tags {
              label
            }
          }
        }
    }
}

    `;

export const propertyMapMigrationQuery = templateJoin`
        query PropertyMapMigration(
    $context: ContextInput!
    $destination: DestinationInput!
    $rooms: [RoomInput!]
    $dateRange: PropertyDateRangeInput
    $sort: PropertySort
    $filters: PropertySearchFiltersInput
    $marketing: PropertyMarketingInfoInput
    $legacyCriteria: LegacyPropertySearchCriteriaInput
    $searchOptions: [PropertySearchOptions!]
    $searchPagination: PaginationInput
    $searchIntent: SearchIntentInput
    $shoppingContext: ShoppingContextInput
) {
    propertySearch(
        context: $context
        destination: $destination
        rooms: $rooms
        dateRange: $dateRange
        sort: $sort
        filters: $filters
        marketing: $marketing
        legacyCriteria: $legacyCriteria
        searchOptions: $searchOptions
        searchPagination: $searchPagination
        searchIntent: $searchIntent
        shoppingContext: $shoppingContext
    ) {
        map {
            bounds {
                northeast {
                    latitude
                    longitude
                }
                southwest {
                    latitude
                    longitude
                }
            }
            center {
                latitude
                longitude
            },
            markers {
                mapMarker {
                    label
                    icon
                    type
                    latLong {
                        latitude,
                        longitude
                    }
                }
                    __typename
                    ...on Property {
                        ...commonPropertyCardFields
                    }
                    ...on PointOfInterest {
                        name: title
                    }
            },
            staticMapSrc
            title
            zoom
            messagingModel {
                title {
                    text
                    theme
                    icon {
                        description
                        id
                    }
                }
                subtitle {
                    text
                    theme
                    icon {
                        description
                        id
                    }
                }
                type
            }
        }
        properties {
            ...commonPropertyCardFields
            star
            starRatingIcon
            availability {
                available
                text
                theme
            }
            offerSummary {
                message
                theme
                messages {
                    message
                    theme
                    type
                }
            }
            priceAfterLoyaltyPointsApplied {
                lead {
                    formatted
                }
                strikeOutType
                strikeOut {
                    formatted
                }
            }
            gallery {
                ...SearchMigrationImage
            }
            mapMarker {
                icon
                label
                type
                latLong {
                    latitude
                    longitude
                }
            }
            neighborhood {
                name
            }
            pinnedDetails {
                heading
            }
            destinationInfo {
                distanceFromMessaging
            }
            propertyTypeBadge
            supportingMessages
            shortList {
                favorited
                saveUrl
                removeUrl
                metaData {
                    chkIn
                    chkOut
                    hotelId
                    roomConfiguration
                }
            }
            sponsoredListing {
                id
                clickRedirectTrackingUrl
                clickTrackingUrl
                details
                detailsHeadline
                hotelImage
                impressionTrackingUrl
                trackingData
                brand
                clickRedirectLinkoffTrackingUrl
                logo
                lotagline
                rating
                slots
                vanityUrl
                rank
                position
            }
            highlightedPropertyDetail
        }
        searchCriteria {
            destination {
                regionId
                regionName
            }
            searchIntent {
                theme
                userIntent
                semdtl
            }
            sort
            filters {
                accessibility
                amenities
                bedroomFilter
                deals
                paymentType
                poi
                priceBuckets
                propertyName
                propertyStyles
                reviewScore {
                    min
                    max
                }
                starList
                structureTypes
                travelerType
            }
        }
        sortAndFilter {
            defaults {
                sort
                regionId
            }
            selected {
                priceFilterPills {
                    aggregate {
                        label
                        value
                    }
                    buckets
                }
                star
            }
            options {
                appliedFilterCount
                sortAndFilter {
                    selected
                    isRange
                    label
                    max
                    min
                    name
                    placeholder
                    step
                    subLabel
                    hiddenThreshold: seeMoreOptionsToggleThreshold
                    options {
                        selectedLabel
                        ariaLabel
                        description
                        icon
                        isSelected
                        label
                        value
                        optionValue
                        range {
                            min
                            max
                        }
                        filterCategory
                    }
                }
            }
        }
        summary {
            resultsSummary {
                __typename
                value
                ... on LodgingLinkMessage {
                    ...SearchMigrationLinkMessage
                }
            }
            loyaltyInfo {
                saveWithPointsMessage
                saveWithPointsActionMessage
            }
        }
    }
}

fragment SearchMigrationLinkMessage on LodgingLinkMessage {
    link {
        ...SearchMigrationLink
    }
    icon {
        id
    }
}

fragment SearchMigrationLink on LodgingLink {
    url
    referrerId
}

fragment SearchMigrationImage on Image {
    description
    url
}

fragment commonPropertyCardFields on Property {
          id
          name
          thumborImage {
                ...SearchMigrationImage
            }
          offerBadge {
                primary {
                    text
                    theme_temp
                    icon_temp {
                        id
                        description
                    }
                }
                secondary {
                    text
                    theme_temp
                    icon_temp {
                        id
                        description
                    }
                }
            }
          price {
                lead {
                    formatted
                }
                strikeOutType
                strikeOut {
                    formatted
                }
                roomNightMessage
            }
          reviews {
                score
                localizedScore
                total
                localizedTotal
                superlative
                localizedSubtitle
            }
          vipMessaging
          infositeURL
      }

    `;

export const propertySearchQuery = templateJoin`
        query PropertySearch(
    $context: ContextInput!
    $destination: DestinationInput!
    $rooms: [RoomInput!]
    $dateRange: PropertyDateRangeInput
    $sort: PropertySort
    $filters: PropertySearchFiltersInput
    $marketing: PropertyMarketingInfoInput
    $legacyCriteria: LegacyPropertySearchCriteriaInput
    $searchOptions: [PropertySearchOptions!]
    $searchPagination: PaginationInput
    $searchIntent: SearchIntentInput
    $shoppingContext: ShoppingContextInput
) {
    propertySearch(
        context: $context
        destination: $destination
        rooms: $rooms
        dateRange: $dateRange
        sort: $sort
        filters: $filters
        marketing: $marketing
        legacyCriteria: $legacyCriteria
        searchOptions: $searchOptions
        searchPagination: $searchPagination
        searchIntent: $searchIntent
        shoppingContext: $shoppingContext
    ) {
        searchCriteria {
            destination {
                regionId
                regionName
            }
            searchIntent {
                theme
                userIntent
                semdtl
            }
            sort
            filters {
                accessibility
                amenities
                bedroomFilter
                deals
                paymentType
                poi
                priceBuckets
                propertyName
                propertyStyles
                reviewScore {
                    min
                    max
                }
                rewards
                starList
                structureTypes
                travelerType
            }
        }
        sortAndFilter {
            defaults {
                sort
                regionId
            }
            selected {
                priceFilterPills {
                    aggregate {
                        label
                        value
                    }
                    buckets
                }
                star
            }
            options {
                appliedFilterCount
                sortAndFilter {
                    selected
                    isRange
                    label
                    max
                    min
                    name
                    placeholder
                    step
                    subLabel
                    hiddenThreshold: seeMoreOptionsToggleThreshold
                    options {
                        selectedLabel
                        ariaLabel
                        description
                        icon
                        isSelected
                        label
                        value
                        optionValue
                        range {
                            min
                            max
                        }
                        filterCategory
                    }
                }
            }
        }
        summary {
            resultsSummary {
                __typename
                value
                ... on LodgingLinkMessage {
                    ...SearchLinkMessage
                }
            }
            loyaltyInfo {
                saveWithPointsMessage
                saveWithPointsActionMessage
            }
        }
    }
}

fragment SearchLinkMessage on LodgingLinkMessage {
    link {
        ...SearchLink
    }
    icon {
        id
    }
}

fragment SearchLink on LodgingLink {
    url
    referrerId
}

    `;

export const removeItemFromCartQuery = templateJoin`
        mutation RemoveItemFromCart($cartId: UUID!, $context: ContextInput!, $itemId: UUID!){
    cartItems(
        id: $cartId, context: $context
    ) {
        remove(id: $itemId) {
            id
            itemCount
        }
    }
}

    `;

export const translateReviewQuery = templateJoin`
        query TranslateReview($context: ContextInput!, $hotelId: String!, $reviewId: String!, $targetLocale: Locale) {
  propertyInfo(context: $context, propertyId: $hotelId) {
    review(id: $reviewId, locale: $targetLocale) {
    ...HotelReview
    }
  }
}


fragment HotelReview on PropertyReview {
    id
    locale
    photos {
        description
        url
    }
    ratingOverall
    submissionTime {
        raw
    }
    text
    title
    userLocation
    userNickname
}

    `;

export const reviewsQuery = templateJoin`
        query Reviews($context: ContextInput!, $propertyId: String!, $pagination: PaginationInput!, $sortBy: PropertyReviewSort!, $filters: PropertyReviewFiltersInput!, $withTop: Boolean!) {
    propertyInfo(propertyId: $propertyId,  context: $context) {
        topReview: reviewInfo(sortBy: NEWEST_TO_OLDEST, pagination: { size: 1 }, filters: { ratings: [4,5] }) @include(if: $withTop) {
            reviews {
                ratingOverall
                superlative
                text
                author
                reviewerVerified
            }

        }
        reviewInfo(sortBy: $sortBy, pagination: $pagination, filters: $filters) {
            summary {
                superlative
                totalCount {
                    raw
                    formatted
                }
                reviewCountLocalized
                averageOverallRating {
                    raw
                    formatted
                }
                cleanliness {
                    raw
                    formatted
                }
                serviceAndStaff {
                    raw
                    formatted
                }
                amenityScore {
                    raw
                    formatted
                }
                hotelCondition {
                    raw
                    formatted
                }
                cleanlinessPercent
                cleanlinessOverMax
                serviceAndStaffPercent
                serviceAndStaffOverMax
                amenityScorePercent
                amenityScoreOverMax
                hotelConditionPercent
                hotelConditionOverMax
                ratingCounts {
                    count {
                        formatted
                        raw
                    }
                    percent
                    rating
                }
                lastIndex
                reviewDisclaimer
            }
            reviews {
                id
                ratingOverall
                superlative
                submissionTime {
                    raw
                }
                title
                text
                locale
                author
                userLocation
                stayDuration
                helpfulReviewVotes
                negativeRemarks
                positiveRemarks
                locationRemarks
                photos {
                    description
                    url
                }
                managementResponses {
                    id
                    date
                    displayLocale
                    userNickname
                    response
                }
                travelers
                themes {
                    icon {
                        id
                        description
                    }
                    label
                }
            }
            sortAndFilter {
                sortAndFilter {
                    name
                    label
                    options {
                        label
                        isSelected
                        optionValue
                    }
                }
            }
        }
    }
}

    `;

export const questionAnswersQuery = templateJoin`
        query QuestionAnswers($context: ContextInput!, $productId: String!, $filters: ProductQuestionFiltersInput!, $pagination: PaginationInput!, $productQuestionTopic: ProductQuestionTopic!, $questionDateFormat: String!) {
    productQuestions(context: $context, productId: $productId, filters: $filters, questionPagination: $pagination, productQuestionTopic: $productQuestionTopic) {
        totalCount {
            raw
        }
        questions {
            answers {
                answer
                answerTime {
                formatted(format: $questionDateFormat),
                raw
                }
                displayName
                id
                upVotes {
                    raw
                }
            }
            createDate {
                formatted(format: $questionDateFormat),
                raw
            }
            id
            question
            questioner
            totalAnswers {
                raw
            }
        }
    }
}

    `;

export const upvotePropertyReviewQuery = templateJoin`
        mutation UpvotePropertyReview($reviewId: String!) {
  upvotePropertyReview(id: $reviewId)
}
    `;
